// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--scale-factor:0.2;--position-x:0;--position-y:0;--position-scale:cover}*{box-sizing:border-box}body,html{padding:0;margin:0;height:100%}#app{font-family:var(--link-font-family,-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"PingFang SC\",\"Hiragino Sans GB\",\"Microsoft YaHei\",\"Helvetica Neue\",Arial,sans-serif);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--link-ink,#292524);height:100%}", ""]);
// Exports
module.exports = exports;
